// ProductCategoryTile section
document.addEventListener("DOMContentLoaded", function () {
  // Function to toggle visibility of tile-desc
  function toggleTileDesc(e) {
    let innerTile = e.target.closest(".inner-tile")
    innerTile.classList.toggle("active")
  }

  let learnMoreButtons = document.querySelectorAll(".mob-learnmore")
  learnMoreButtons.forEach(function (button) {
    button.addEventListener("click", function (e) {
      toggleTileDesc(e)
    })
  })
})
